import React, { Component } from "react";
import FacebookLogin from "react-facebook-login";
import {register} from '../config/Variables';
import {appId} from '../config/Settings';

export default class Facebook extends Component {
  state = {
    isLoggedIn: false,
    first_name: "",
    email: "",
    provider_id: "",
    provider:"Facebook",
    device_name:"nokia",
    registered_by: "website"
   // password:"123456"
  };

   responseFacebook = response => {
    this.setState({
      isLoggedIn: true,
      first_name: response.name,
      last_name: response.name,
      name: response.name,
      email: response.email,
      profile_url: response.picture.data.url,
      provider_id: response.id
    });
 //   let item = {userID, email, Facebookname,Provider,profile_url,providerID,device_name};
    let result =   fetch(register,{
  method: 'POST',
  headers : {
    "Content-Type" : "application/json",
    "Accept" : 'application/json'
  },
  body: JSON.stringify(this.state)
}) .then(response => response.json())
.then(data =>  {
  if(data.message.code =='200'){
    localStorage.setItem("user-info", JSON.stringify(data));
    //history('/add');
   

    if(data.message.newUser =='1'){
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
      event: 'sign_up',
      user_id: data.user.id,
      method: "facebook"
      });
      this.props.samirCallback("successsfirstfacebook");
    }else{
      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
      event: 'login',
      user_id: data.user.id,
      method: "facebook"
      });
      this.props.samirCallback("successssecondfacebook");
    }
  }
  if(data.message.code =='401'){
    this.props.samirCallback("logout");
  }

});



  };

  componentClicked = () => console.log("clicked");

  render() {
    let fbContent;

    if (this.state.isLoggedIn) {
      fbContent = (
        <div
          style={{
            width: "400px",
            margin: "auto",
            background: "white",
            padding: "20px"
          }}
        >
      
        </div>
      );
    } else {
      fbContent = (
        <FacebookLogin
          appId={appId}
          fields="name,email,picture"
          onClick={this.componentClicked}
          callback={this.responseFacebook}
          cssClass="button expanded button-facebook"
          icon='fa-facebook'
          textButton="الدخول بحساب فيسبوك"
        />
      );
    }

    return <div>{fbContent}</div>;
  }
}